import React from "react";
import {
    Raycaster, Vector2, DoubleSide, WebGLRenderer, PerspectiveCamera, Scene,
    Group, TextureLoader, Mesh, PlaneGeometry, MeshBasicMaterial, MeshStandardMaterial
} from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import arrow from '../../assets/models/arrow-red.glb';
import { modelArr } from "../../data/model";
import $ from "jquery";
import gsap from 'gsap';
import thermatruPlayBtn from '../../assets/images/MicrosoftTeams-image.png';
import fyponPlayBtn from '../../assets/images/MicrosoftTeams-image (2).png';
import fyponBlackPlayBtn from '../../assets/images/backbutton.png';
import Fiberon from '../../assets/images/prmedia/Fiberon.png';
import Fortune from '../../assets/images/prmedia/Fortune.png';
import Larson from '../../assets/images/prmedia/Larson.png';
import Solar from '../../assets/images/prmedia/Solar.png';
import { callAnalyticsAPI } from "../../api/user";
let custom_play = null
const loader = new TextureLoader();

class Canvas2d extends React.Component {
    constructor(props) {
        super(props);
        this.backMapArr = [];
        this.hotArr = [];
        this.imageArr = [];
        this.hotMeshArr = [];
        this.hotOverArr = [];
        this.hotRingArr = [];
        this.hotOverTextArr = [];
        this.infoSpotMeshArr = [];
        this.raycaster = new Raycaster();
        this.imgEl = true;
        this.mouse = new Vector2();
        this.cWidth = window.innerWidth;
        this.cHeight = window.innerHeight;
        this.previousUiNavigationHoveredObject = null;
        const { pageKey } = props;
        this.state = { pageKey: pageKey }
        this.selectedHotspot = null;
        this.scene = null;
        this.needsUpdate = true;
        // this.logoImage = null;
    }

    componentDidMount() {
        this.initScene();
        this.animate();
        var that = this;
        $('#myModal').on('hide.bs.modal', function (e) {
            that.animate(that.defaultFps);
        });

    }

    componentDidUpdate(prevProps) {
        if (prevProps.selMenu !== this.props.selMenu && this.props.pageKey === 'canvas-2d') {
            this.appLogoToggle("thermatru");
            this.needsUpdate = true;
            this.animate()

            const reqData = {};
            let user_id = sessionStorage.getItem("user_id");

            if (user_id) {
                reqData.user_id = user_id;
                reqData.area_id = "prmedia";
                reqData.resource_id = "prmedia";
                reqData.resource_type = "area";
                if (this.props.prevScene) {
                    reqData.prev_area = this.props.prevScene;

                } else {
                    reqData.prev_area = 0;

                }
                reqData.spent_time = 0;
                reqData.total_time = 0;
                reqData.video_status = "";
                reqData.download = 0;
                reqData.guided_mode = 0;
                callAnalyticsAPI(reqData)
            }
        }

        if (prevProps.selMenu !== this.props.selMenu && this.props.pageKey !== 'canvas-2d') {
            this.needsUpdate = false;
        }

        
        // if(prevProps.deviceDirection !== this.props.deviceDirection){

        //     if(this.props.deviceDirection === "port"){
        //         this.needsUpdate = true
        //     }else{

        //         this.needsUpdate = false
        //         this.animate()
        //     }
        // }
    }

    componentWillUnmount() {
        this.needsUpdate = false;
        document.getElementById("canvas-container-2d").removeEventListener('pointermove', this.onMouseMove);
        document.getElementById("canvas-container-2d").removeEventListener('click', this.onClickWindow);
        document.getElementById("canvas-container-2d").removeEventListener('touchmove', this.handleMove);
        document.getElementById("canvas-container-2d").removeEventListener('touchenter', this.handleEnter);
        window.removeEventListener('resize', this.setCanvasSize);
        document.getElementById("canvas-container-2d").removeEventListener('touchenter', this.handleEnter);
    }

    initScene = () => {
        this.renderer = new WebGLRenderer({ antialias: true, preserveDrawingBuffer: true, powerPreference: "high-performance" });
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        if (!document.getElementById("canvas-container-2d")) return false;
        document.getElementById("canvas-container-2d").appendChild(this.renderer.domElement);
        this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
        document.getElementById("canvas-container-2d").addEventListener('pointermove', this.onMouseMove);
        document.getElementById("canvas-container-2d").addEventListener('click', this.onClickWindow);
        document.getElementById("canvas-container-2d").addEventListener('touchmove', this.handleMove);
        document.getElementById("canvas-container-2d").addEventListener('touchenter', this.handleEnter);
        window.addEventListener('resize', this.setCanvasSize);
        document.getElementById("canvas-container-2d").addEventListener('touchenter', this.handleEnter);
        this.camera = new PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.01, 150);
        this.camera.position.set(0, 0, 0.01);
        this.scene = new Scene();
        this.totalGroup = new Group();
        this.scene.add(this.totalGroup);

        let that = this;
        let selScene = "prmedia";
        let modelItem = modelArr.find(item => item.key === selScene);

        this.__addBackground();
        this.info = null;

        if (modelItem.infospot) {
            let text = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RJREFUeNrsW+txo0AMhjQAHeAO4CrAHZAO7KvA6cDpICU4Hdgd2FcBvgpwByQVcFJYMiThiKRdQDjWjMZ/MKy+1Wslrefd6GeTP/QHqqoK4GcJnAAvDPfRxfDJ9/0/s0QVhI6Bt8BFZU+5eVc0B8FXZsFD0R440yZ0ALwBLqvxqFABBCwidaTmUjpOYhpm17eVDkLN24wtfF7po93gYRC9O4Yn4FCpHz5jyIXw+eocAGNrZ8XCv4MAAPyiPnzHSGYOMxAeKeGYg08EIDeZnIxeXsBwwHLO5/r3fxQCvklS8/29LRDPoAm/XTi9nTxIQZRaQW6Er+FyAL52A+lFYRVlVy4yO5ngcSwTvIvT1AaIVCp8xM7uSng8y9wJ3qURsqwxkABw5B1ZIDWIomGE/6wNZTlsjmBSXAbGRb1DQwvfMJoXn2IOAAVL7V3aO5VXbPd0HMbxDWXzFOb7hJQU88mve3qaTviG93t3WmAqOXS7n1r4JjrwnGLUlwqvyY5ivdaR+L7CuefhgfOPtb3zw0RHw+63mZ4oFZ0aYFRjQcuyn/UdgR4fqU8uOqtIZO+P9qZt9xtfIDgjtH0A7bTXd5qb2hccDmQtuD4A3kohZ+qTyy4AQscfGZ/omxN+KYigYdD+GtbqppGCoC6+UCpBQDIAfN9TTWQxakHuvB9ONwBuAHApUtylFqytDQAthiwWegGgr+0k14Ak0QuAYG18DdAMwHJppQEX0l/tOzbDJUF0AC5yDcBMMMv0AYAbE4ZsDbiegkhOLmXmfWHwQLa1NNWz+7gWum869ZXEYlb/T0shhNc3jL85SzCaItLOr0vebt02R1iNkam6Qg1jU2aIdjmrKzx2X7DdH+T1AwrGkbri9ZzG6gzbdYh5sZs9CjeWOfCbovTG6CcAUvZndA5IlOJpUvE0KDYsXfoF1KxcPJtpl7ayJ0U+zGXs7MwCbf0o/zz2rx3UGN9GY+0GojFSYLxGgb5TczQhbLvbTYeR7Z46J6h9RPZL98IjjsySCiLwor+mm3KZgfAnjzkvzDUHjZPiVhPj1wLCbjQda12T0XJhYpoKjUmWygmFz1XcJjMJ09iXplaqXK+ZLXZ1V7BXcNHs78hgZOaOnzMHJ576dpEI2ThLkz8gs6/OenO+PnujmdA/AQYAKG5/WVyvYeIAAAAASUVORK5CYII=';
            let blueText = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABABAMAAABYR2ztAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAB5QTFRFAAAA////DnzBAHnCBHjABne//+/vmsrnmsDdM3exogC3vAAAAAp0Uk5TAP///////////36JFFYAAAECSURBVHic7ZXRDcIwDESTDRJVFQMwQWsQg3QCZmEEFkZQJznHTiIVPrm/9p7ujGgc536quCs0bB+zTAR8k4hSivCxTyg/xm6BijACJGH5CJgBOEUGzkR0WXVEekOsOiIFbFQRQQYQSEbsDxMCCwJeB9AVO3ZgFgBHBGigStChJ3jrngFvA6XjA5xqnzsyoAIAsBtSRwIeI0D7tI4A+gMG8DyQIP+L6RvANzrkFzUGVMeSgcYQeYR0cDarIbrmwYAG8/ByQMDjP+sAuR86C4Q7yhS8HcoW4+cp/ZKbDIA9KvJhDTYWKaxaGyi+HeFQ/QI7wrk+Mbq0htee9scXKxC2fVQvY3C38vDhRcIAAAAASUVORK5CYII=';
            let mapText = '';

            modelItem.infospot.forEach(val => {
                if (val.name === "prmedia_thermatru") {
                    custom_play = thermatruPlayBtn;
                }

                if (val.name === "prmedia_fypon") {
                    custom_play = fyponPlayBtn;
                }

                const CustomPlayTexture = loader.load(custom_play);
                const ModalTexture = loader.load(text);

                if (val.name.includes("_modal")) {
                    if (val.color !== undefined && val.color === 'blue') {
                        const blueTexture = loader.load(blueText);
                        mapText = blueTexture;
                    } else {
                        mapText = ModalTexture;
                    }

                    this.info = new Mesh(
                        new PlaneGeometry(1, 1),
                        new MeshBasicMaterial({ map: mapText, side: 2, transparent: true })
                    );
                } else {
                    mapText = CustomPlayTexture;
                    this.info = new Mesh(
                        new PlaneGeometry(1.6, 1.6),
                        new MeshBasicMaterial({ map: mapText, side: 2, transparent: true })
                    );
                }

                this.info.position.copy(val.pos)
                this.info.name = val.name;
                if (val.needRotation) {
                    this.info.rotation.y = val.rot.y;
                } else {
                    this.info.rotation.y = Math.PI / 2;
                }
                that.totalGroup.add(this.info)
                that.infoSpotMeshArr.push(this.info)
            });
        }
        this.__imageElements(modelItem);
        // this.__loadPointer();
    }

    __loadPointer = () => {
        const backTexture = loader.load(fyponBlackPlayBtn);

        for (let i = 0; i < 4; i++) {
            let arrowObj = this.info.clone();
            arrowObj.material.map = backTexture;
            arrowObj.position.set(14.120, -2.230 - (i * 1.3), -16.230);
            arrowObj.scale.set(0.8, 0.8, 1)
            this.arrow.push(arrowObj);
            this.scene.add(arrowObj);
        }

    }

    __imageElements = (modelItem) => {
        const blackTexture = loader.load(fyponBlackPlayBtn);
        modelItem.imageElements.forEach(nav => {
            const { name, pos, link, rot } = nav;
            let FiberonText = loader.load(Fiberon);
            if (name === 'ImageEl_fiberon') FiberonText = loader.load(Fiberon);
            if (name === 'ImageEl_fortune_brands') FiberonText = loader.load(Fortune);
            if (name === 'ImageEl_larson') FiberonText = loader.load(Larson);
            if (name === 'ImageEl_solar_innovations') FiberonText = loader.load(Solar);
            const geometry = new PlaneGeometry(3, 1, 1, 1);
            const material = new MeshBasicMaterial({ map: FiberonText, side: 2, transparent: true, opacity: 0 });
            const plane = new Mesh(geometry, material);
            plane.name = name;
            plane.position.set(pos.x, pos.y, pos.z);
            plane.link = link;
            // plane.rotation.z = -0.01;
            plane.rotation.y = rot.y;
            plane.visible = true;

            /** Play Button commented for logo **/


            let arrowObj = this.info.clone();
            arrowObj.material.map = blackTexture;
            arrowObj.scale.set(0.8, 0.8, 1)
            arrowObj.position.set(13.90, pos.y, pos.z);
            arrowObj.link = link;
            arrowObj.elmname = name;

            this.infoSpotMeshArr.push(arrowObj);


            this.imageArr.push(plane);
            this.scene.add(plane, arrowObj);
        });
    }

    __addBackground = () => {
        const loader = new TextureLoader();
        let that = this
        // this.props.changeLoaderStatus(true)
        const geometry = new PlaneGeometry(52.4, 26);
        const material = new MeshBasicMaterial({ map: null, side: 2 })
        const plane = new Mesh(geometry, material);
        plane.position.set(0, 0, -16.240);
        plane.name = 'PR Media BG';
        this.scene.add(plane);


        loader.load('tinified/PR_Image-logo.jpg', function (texture) {

            plane.material.map = texture
            plane.material.needsUpdate = true
            //that.props.changeLoaderStatus(false)

        });



    }

    getClickObj = (e, arr) => {
        if (!e.touches && !e.changedTouches) e.touches = [{ pageX: e.pageX, pageY: e.pageY }];
        const touch = e.touches[0] || e.changedTouches[0];
        if (!touch) return;
        const posX = touch.pageX, posY = touch.pageY;
        this.mouse.x = (posX / window.innerWidth) * 2 - 1;
        this.mouse.y = - (posY / window.innerHeight) * 2 + 1;
        this.raycaster.setFromCamera(this.mouse, this.camera);
        const interObj = this.raycaster.intersectObjects(arr)[0];
        return interObj;
    }

    handleEnter = (e) => {
        ;[...e.changedTouches].forEach(touch => {
            this.hoverHot = null;
            const interHot = this.getClickObj(touch, this.hotMeshArr.filter(item => item.visible === true));
            const interInfoSpot = this.getClickObj(touch, this.infoSpotMeshArr);
            const imageInfor = this.getClickObj(touch, this.imageArr);
            $('#canvas-container').css({ cursor: 'default' });
            if (interInfoSpot) { $('#canvas-container').css({ cursor: 'pointer' }); return; }

            if (interInfoSpot || (imageInfor && this.imgEl)) {
                if (imageInfor.object.visible) {
                    $('#canvas-container').css({ cursor: 'pointer' });
                }
                return;
            }
            this.selectedHotspot = null;
            if (interHot) {
                this.hoverHot = interHot.object;
                if (interHot.object.parent.visible) {
                    this.selectedHotspot = interHot.object;
                    $('#canvas-container').css({ cursor: 'pointer' });
                }
            }
        });
    }

    handleMove = (e) => {
        ;[...e.changedTouches].forEach(touch => {
            this.hoverHot = null;
            const interHot = this.getClickObj(touch, this.hotMeshArr.filter(item => item.visible === true));
            const interInfoSpot = this.getClickObj(touch, this.infoSpotMeshArr);
            const imageInfor = this.getClickObj(touch, this.imageArr);
            $('#canvas-container').css({ cursor: 'default' });
            if (interInfoSpot) { $('#canvas-container').css({ cursor: 'pointer' }); return; }

            if (interInfoSpot || (imageInfor && this.imgEl)) {
                if (imageInfor.object.visible) {
                    $('#canvas-container').css({ cursor: 'pointer' });
                }
                return;
            }
            this.selectedHotspot = null;
            if (interHot) {
                this.hoverHot = interHot.object;
                if (interHot.object.parent.visible) {
                    this.selectedHotspot = interHot.object;
                    $('#canvas-container').css({ cursor: 'pointer' });
                }
            }
        });
    }

    onMouseMove = (e) => {
        if (this.controlChange) return;
        this.hoverHot = null;
        const interHot = this.getClickObj(e, this.hotMeshArr.filter(item => item.visible === true));
        const interInfoSpot = this.getClickObj(e, this.infoSpotMeshArr);
        const imageInfor = this.getClickObj(e, this.imageArr);

        $('#canvas-container-2d').css({ cursor: 'default' });
        if (interInfoSpot) { $('#canvas-container-2d').css({ cursor: 'pointer' }); return; }

        if (interInfoSpot || (imageInfor && this.imgEl)) {
            if (imageInfor.object.visible) {
                this.__resetLogoSize();
                //   this.logoImage = null;
                // let duration = 0.05;
                //   this.logoImage = imageInfor.object;
                //   imageInfor.object.scale.set(1.2, 1.2, 1);
                $('#canvas-container-2d').css({ cursor: 'pointer' });
            }
            return;
        }

        // this.logoImage.scale.set(1, 1, 1);
        // this.logoImage = null;
        this.selectedHotspot = null;
        if (interHot) {
            this.hoverHot = interHot.object;
            if (interHot.object.parent.visible) {
                this.selectedHotspot = interHot.object;
                $('#canvas-container-2d').css({ cursor: 'pointer' });
            }
        }
    }

    __resetLogoSize = () => {
        this.imageArr.forEach(child => {
            if (child.scale.x > 1) {
                child.scale.set(1, 1, 1);
            }
        })
    }

    onClickWindow = (e) => {
        const interHot = this.getClickObj(e, this.hotMeshArr.filter(item => item.visible === true));
        const interInfoSpot = this.getClickObj(e, this.infoSpotMeshArr);
        const imageInfor = this.getClickObj(e, this.imageArr);

        //Redirect Ui Areal Views
        if (imageInfor) {
            if (imageInfor.object.visible) {
                if (imageInfor.object?.link && this.imgEl) {

                    let redirectLink = imageInfor.object.link
                    if (imageInfor.object.name === "ImageEl_fiberon") {
                        let user_email = sessionStorage.getItem("user_email");
                        if (user_email) {
                            redirectLink = "https://fiberon2023.thetunagroup.com/?email=" + user_email
                        }

                    }

                    const reqData = {}
                    let user_id = sessionStorage.getItem("user_id");
                    if (user_id) {
                        reqData.user_id = user_id;
                        reqData.area_id = "prmedia";
                        reqData.resource_id = imageInfor.object.name;
                        reqData.resource_type = "redirect";
                        reqData.prev_area = 0;
                        reqData.spent_time = 0;
                        reqData.total_time = 0;
                        reqData.video_status = "";
                        reqData.download = 0;
                        reqData.guided_mode = 0;
                        callAnalyticsAPI(reqData)
                    }
                    window.open(redirectLink, '_blank');
                    return;

                }
            }
        }

        /** Open Modal Pop up Content **/
        if (interInfoSpot) {

            if (interInfoSpot.object?.link) {
                let redirectLink = interInfoSpot.object.link;

                if (interInfoSpot.object.elmname === "ImageEl_fiberon") {
                    let user_email = sessionStorage.getItem("user_email");
                    if (user_email) {
                        redirectLink = "https://fiberon2023.thetunagroup.com/?email=" + user_email
                    }

                }

                const reqData = {}
                let user_id = sessionStorage.getItem("user_id");
                if (user_id) {
                    reqData.user_id = user_id;
                    reqData.area_id = "prmedia";
                    reqData.resource_id = interInfoSpot.object.elmname;
                    reqData.resource_type = "redirect";
                    reqData.prev_area = 0;
                    reqData.spent_time = 0;
                    reqData.total_time = 0;
                    reqData.video_status = "";
                    reqData.download = 0;
                    reqData.guided_mode = 0;
                    callAnalyticsAPI(reqData)
                }
                window.open(redirectLink, '_blank');     
                return;           
            }

            let analyticsNotIncludedAreaNoTimeSpendNeed = [
                "prmedia_fypon", "prmedia_thermatru",
            ]

            if (analyticsNotIncludedAreaNoTimeSpendNeed.includes(interInfoSpot.object.name)) {
                const reqData = {}
                let user_id = sessionStorage.getItem("user_id");
                if (user_id) {
                    reqData.user_id = user_id;
                    reqData.area_id = "PR & Media";
                    reqData.resource_id = interInfoSpot.object.name;
                    reqData.resource_type = "section";
                    reqData.prev_area = 0;
                    reqData.spent_time = 0;
                    reqData.total_time = 0;
                    reqData.video_status = "";
                    reqData.download = 0;
                    reqData.guided_mode = 0;
                    callAnalyticsAPI(reqData)
                }

            }
            //Redirect To Image Slider Navigation Page
            if (interInfoSpot.object.name === "fypon_explore") {
                this.props.changeRender360Map("fypon_explore", true);
                this.props.handleExploreUiVisibility();
                return;
            }
            if (interInfoSpot.object.name === "rotation_keysuccess") {
                this.animate(this.lowFps);
            }

            /** Open Modal Pop up **/
            this.props.setModalPopupContent(interInfoSpot.object.name);
            return;
        }
        if (interHot) {
            if (interHot.object.parent.visible) {
                if (this.props.guidedPathvisibility) {
                    this.props.updateGuidedPathArrayIndex(interHot.object.hotId);
                }
                this.render3dCubeMap(null, interHot.object.hotId);
            }
        }
    }

    getHotObject = (e) => {
        if (!this.hotArr || !this.hotArr.length) return;
        var posX, posY;
        if (e.clientX && e.clientY) {
            posX = e.clientX;
            posY = e.clientY;
        }
        else if (e.touches || e.changedTouches) {
            const touch = e.touches[0] || e.changedTouches[0];
            posX = touch.pageX; posY = touch.pageY;
        }
        else
            return;
        this.mouse.x = (posX / window.innerWidth) * 2 - 1;
        this.mouse.y = - (posY / window.innerHeight) * 2 + 1;
        this.raycaster.setFromCamera(this.mouse, this.camera);
        return this.raycaster.intersectObjects(this.hotArr)[0];
    }

    appLogoToggle = (type) => {
        $(".logo-cls").removeClass("d-none");
        if (type === "thermatru") {
            $("#fypon-logo").addClass('d-none')
        } else if (type === "fypon") {
            $("#thermatru-logo").addClass('d-none')
        } else {
            $("#thermatru-logo").addClass('d-none')
        }
    }

    setCanvasSize = () => {
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(window.innerWidth, window.innerHeight);
    }

    animate = () => {
        if (!this.needsUpdate) return;
        this.renderer.render(this.scene, this.camera);
        this.camera.lookAt(0, 0, 0);
        window.requestAnimationFrame(this.animate)
    }

    render() {
        const { tSize } = this.props
        return (
            <div className={`canvas_div wrapper test back-board ${this.props.pageKey === 'canvas-2d' ? 'active' : ''}`} style={{ width: tSize.w, height: tSize.h }}>
                <div id="canvas-container-2d"></div>
                <div className='hot-wrapper hotOver-wrapper' id='hotWrapper'>
                    <div className='hot-inner' id='hotInner'>
                        <label id='hotLabel'></label>
                        <div className='hot-arrow'></div>
                    </div>
                </div>
                {/* <div id="render2dWrapper"></div> */}
                <div id="hotsport"> </div>
            </div>
        )
    }
}

export default Canvas2d;